export default {
    apiCallsInProgress: 0,
    facilities: [],
    projects: []
}